import { render, staticRenderFns } from "./PageContentContainer.vue?vue&type=template&id=30cf4000&"
import script from "./PageContentContainer.vue?vue&type=script&lang=js&"
export * from "./PageContentContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports